import { DEMO } from "@/demo/demo";

export default function DemoBanner() {
  if (!DEMO) return null;
  return (
    <div role="note" className="w-full bg-amber-500 text-zinc-950 text-xs sm:text-sm px-4 py-1.5 flex flex-wrap items-center justify-center gap-x-3 gap-y-0.5">
      <span><strong>Read-only demo.</strong> Fictional dossier (invented companies, heat and certificate numbers). Results are recorded from a real pipeline run, not processed live. Row 4 (SW 90deg Elbow) is a 42-piece certificate series; the verifier attached 5 pages for it, so it is flagged for review, a known packet-size limit.</span>
      <a href="https://traceqcai.tech" className="underline font-medium">Request a demo on your own dossier</a>
    </div>
  );
}
